// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"92895fd7","796":"1d9de56b"}[chunkId] + ".chunk.js";
};